import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const FieldInput = ({ f, value, onChange }) => {
  const tid = `field-${f.key}`;
  if (f.type === "select")
    return (
      <Select value={value || undefined} onValueChange={onChange}>
        <SelectTrigger data-testid={tid} className="bg-white"><SelectValue placeholder="Select…" /></SelectTrigger>
        <SelectContent className="bg-white">
          {f.options.map((o) => <SelectItem key={o} value={o} data-testid={`${tid}-option-${o.replace(/\s+/g, "-").toLowerCase()}`}>{o}</SelectItem>)}
        </SelectContent>
      </Select>
    );
  if (f.type === "textarea")
    return <Textarea data-testid={tid} rows={3} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="bg-white" />;
  return <Input data-testid={tid} type={f.type === "number" ? "number" : f.type === "date" ? "date" : "text"}
    value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="bg-white" />;
};

export const DynamicFields = ({ typeDef, values, onChange, highlight = [] }) => (
  <div className="grid sm:grid-cols-2 gap-4">
    {typeDef.fields.map((f) => (
      <div key={f.key} className={`space-y-1.5 ${f.type === "textarea" ? "sm:col-span-2" : ""}`}>
        <Label className="text-xs font-semibold text-slate-600">
          {f.label}{f.required && <span className="text-rose-600 ml-0.5">*</span>}
        </Label>
        <div className={highlight.includes(f.key) ? "ring-2 ring-amber-300 rounded-md transition-shadow" : ""}>
          <FieldInput f={f} value={values[f.key]} onChange={(v) => onChange({ ...values, [f.key]: v })} />
        </div>
      </div>
    ))}
  </div>
);

export const FieldsGrid = ({ typeDef, values }) => (
  <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-4" data-testid="record-fields-grid">
    {typeDef.fields.map((f) => (
      <div key={f.key} className={f.type === "textarea" ? "sm:col-span-2" : ""}>
        <dt className="text-xs font-semibold uppercase tracking-wider text-slate-500">{f.label}</dt>
        <dd className="mt-1 text-sm text-slate-900 whitespace-pre-wrap" data-testid={`value-${f.key}`}>
          {values[f.key] !== undefined && values[f.key] !== "" ? String(values[f.key]) : <span className="text-slate-400">—</span>}
        </dd>
      </div>
    ))}
  </dl>
);
